<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.systemPost.form.postName')" prop="postName">
        <a-input v-model="form.postName" :placeholder="$t('views.systemPost.form.placeholderInput')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemPost.form.postCode')" prop="postCode">
        <a-input v-model="form.postCode" :placeholder="$t('views.systemPost.form.placeholderInput')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemPost.form.postSort')" prop="postSort">
        <a-input-number v-model="form.postSort" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemPost.form.status')" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in localizedStatusOptions" :key="index" :value="parseInt(d.value)">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemPost.form.remark')" prop="remark">
        <a-input v-model="form.remark" :placeholder="$t('views.systemPost.form.placeholderInput')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.systemPost.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.systemPost.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getPost, addPost, updatePost } from '@/api/system/post'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: 1,
        remark: undefined
      },
      open: false
    }
  },
  computed: {
    localizedStatusOptions () {
      return this.localizeDictOptions(this.statusOptions, 'views.systemPost.dict.status')
    },
    rules () {
      return {
        postName: [{ required: true, message: this.$t('views.systemPost.form.rules.postNameRequired'), trigger: 'blur' }],
        postCode: [{ required: true, message: this.$t('views.systemPost.form.rules.postCodeRequired'), trigger: 'blur' }],
        postSort: [{ required: true, message: this.$t('views.systemPost.form.rules.postSortRequired'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    localizeDictOptions (options, keyPrefix) {
      return (options || []).map(item => {
        const i18nKey = `${keyPrefix}.${item.value}`
        return {
          ...item,
          label: this.$te(i18nKey) ? this.$t(i18nKey) : item.label
        }
      })
    },
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.form = {
        id: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: 1,
        remark: undefined
      }
    },
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = this.$t('views.systemPost.form.titleAdd')
    },
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getPost(postId).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.systemPost.form.titleEdit')
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updatePost(this.form).then(() => {
              this.$message.success(this.$t('views.systemPost.msg.updateSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPost(this.form).then(() => {
              this.$message.success(this.$t('views.systemPost.msg.addSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
